import { render, staticRenderFns } from "./DashboardVentasResumen.vue?vue&type=template&id=1c96daae&scoped=true&lang=pug"
import script from "./DashboardVentasResumen.vue?vue&type=script&lang=js"
export * from "./DashboardVentasResumen.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentasResumen.vue?vue&type=style&index=0&id=1c96daae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96daae",
  null
  
)

export default component.exports